var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{staticClass:"ribbon"},[_vm._v("\n\t"+_vm._s(_vm.text)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }